{
  "welcome": "Ласкаво просимо до",
  "instructions": "Натисніть нижче, щоб розпочати процес реєстрації.",
  "startCheckIn": "Розпочати реєстрацію",
  "missingWarehouseTitle": "Склад не вказано",
  "missingWarehouseMessage": "Посилання недійсне: у ньому повинен бути вказаний ID складу",
  "recaptchaAttribution": "Цей сайт захищений reCAPTCHA. До нього застосовуються {privacyPolicy} і {termsOfService} Google.",
  "recaptchaPrivacyPolicy": "Політика конфіденційності",
  "recaptchaTermsOfService": "Умови використання",
  "lookupTitle": "Додайте довідковий номер або номер підтвердження, щоб знайти свій запис",
  "referenceNumberLabel": "Довідковий номер або номер підтвердження",
  "referenceNotFoundError": "Довідковий номер або номер підтвердження не відповідає жодному дійсному запису.",
  "checkIn": "Зареєструватися",
  "loadTypeLabel": "Тип вантажу",
  "directionLabel": "Напрямок",
  "operationLabel": "Операція",
  "dockLabel": "Док",
  "orDivider": "або",
  "noReferenceTitle": "У мене немає номера підтвердження",
  "noReferenceDescription": "Продовжити без запису, використовуючи стандартний процес реєстрації.",
  "checkInWithoutAppointment": "Зареєструватися без запису",
  "readyToCheckInTitle": "Готові зареєструватися?",
  "readyToCheckInDescription": "Натисніть нижче, щоб почати. Свої дані ви введете на наступному екрані.",
  "referenceRequiredHint": "Для реєстрації в цьому місці потрібен номер посилання.",
  "haveAppointment": "У мене є запис",
  "direction": {
    "inbound": "Вхідний",
    "outbound": "Вихідний",
    "inOut": "Вхідний та вихідний",
    "load": "Завантаження",
    "unload": "Розвантаження"
  },
  "operation": {
    "live": "Наживо",
    "drop": "Залишення",
    "other": "Інша"
  }
}
